module.exports = __webpack_public_path__ + "static/media/02_05.9b7b122c.png";